<script setup lang="ts">
import type { Component } from 'vue'
import type { UiTone } from '~/utils/ui'
withDefaults(
  defineProps<{
    as?: string | Component
    padding?: 'none' | 'sm' | 'md' | 'lg'
    radius?: 'sm' | 'md' | 'lg'
    clip?: boolean
    border?: boolean
    shadow?: 'none' | 'sm' | 'md'
    tone?: UiTone
    interactive?: boolean
    selected?: boolean
    disabled?: boolean
  }>(),
  {
    padding: undefined,
    radius: undefined,
    border: undefined,
    shadow: undefined,
    tone: undefined,
    interactive: undefined,
    selected: undefined,
    disabled: undefined,
    as: 'article',
    clip: true,
  },
)
</script>
<template>
  <UiSurface
    v-bind="$props"
    class="ui-card"
    ><template
      v-if="$slots.header"
      #header
      ><header class="ui-card-header"><slot name="header" /></header></template
    ><slot /><template
      v-if="$slots.footer"
      #footer
      ><footer class="ui-card-footer"><slot name="footer" /></footer></template
  ></UiSurface>
</template>
